import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { MOCKUP_IMAGE } from './data/content';

/** Arranca la descarga de la imagen del hero y de las fuentes cuanto antes. */
const addHint = (rel: string, href: string, as?: string) => {
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  if (as) link.as = as;
  if (rel === 'preconnect') link.crossOrigin = '';
  document.head.appendChild(link);
};
addHint('preload', MOCKUP_IMAGE, 'image');
addHint('preconnect', 'https://fonts.gstatic.com');
addHint('preconnect', 'https://cdn.magicpatterns.com');
// La tienda es el destino de todos los CTA: abrir la conexión antes acelera el salto.
addHint('preconnect', 'https://tufenixdigital.store');
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-209" data-mp="2tws81wmk9g30" />);
}